import React from 'react';

import { useDirection, useLanguage } from '../app-config-provider';
import LocalAntdConfigProvider from './LocalAntdConfigProvider';

const AntdConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const language = useLanguage();
  const direction = useDirection();
  return (
    <LocalAntdConfigProvider language={language} direction={direction}>
      {children}
    </LocalAntdConfigProvider>
  );
};

export default AntdConfigProvider;
